<template>
  <div>

    <div v-if="is_house_type_available == '1'">
      <ListingTable :columnCount="5">
        <template v-slot:thead>
          <thead>
            <tr>
              <th class="simple-table-th">#</th>
              <th class="simple-table-th">House Type</th>
              <th class="simple-table-th">Size(sqf)</th>
              <th class="simple-table-th">Duration</th>
              <th class="simple-table-th">Price($)</th>
              <th class="simple-table-th">Man Power</th>
              <th class="simple-table-th">Service Synced With Stripe</th>
              <th class="simple-table-th">View All Slots</th>
              <th class="simple-table-th">Created</th>
            </tr>
          </thead>
        </template>
        <template v-slot:tbody>
          <!-- {{ slots }} -->
          <tbody class="custom-border-bottom">
            <template v-if="allSlots?.length > 0">
              <tr class="alternate-listing-row" v-for="(row, index) in allSlots" :key="index">
                <td class="simple-table-td">{{ index + 1 }}</td>
                <td class="simple-table-td">{{ row?.house_type }}</td>
                <td class="simple-table-td">{{ row?.size }}</td>
                <td class="simple-table-td">
                  <div>
                    {{ row?.duration_type == 'Hours' ? row?.hour / 60 : row?.hour }}
                    {{ row?.duration_type }}
                  </div>
                </td>
                <td class="simple-table-td">{{ row?.price }}</td>
                <td class="simple-table-td">{{ row?.man_power }}</td>
                <td class="font-size-18 py-1">
                  <span v-if="row?.is_product_sync && row?.is_product_sync == 1">
                    <v-chip small label color="blue" outlined class="text-white">
                      Synced
                    </v-chip>
                  </span>
                  <span v-else>
                    <v-chip small label color="red" outlined class="text-white">
                      Not Synced
                    </v-chip>
                  </span>
                </td>
                <td class="simple-table-td">
                  <v-icon small class="cursor-pointer" @click="viewSlotInfo(row)">mdi-eye</v-icon>
                </td>
                <td class="simple-table-td">{{ row?.added_at }}</td>
              </tr>
            </template>
            <tr v-else>
              <td colspan="6" class="py-4">
                <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
                  <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
                  Uhh... There are no slot at this moment.
                </p>
              </td>
            </tr>
          </tbody>
        </template>
      </ListingTable>
      <Dialog v-if="viewSlots" :commonDialog="viewSlots" :dialogWidth="768">
        <template v-slot:title>Slot Schedule</template>
        <template v-slot:body>
          <v-container>
            <table width="100%">
              <thead>
                <th>S.no</th>
                <th>Slots</th>
                <th>Slot Duration</th>
                <th>Active</th>
                <th>Delete</th>
              </thead>
              <tr v-for="(row, index) in viewSlotData" :key="index">
                <td class="font-size-14 font-weight-500" align="center" valign="middle">
                  {{ index + 1 }}
                </td>
                <td>{{ row.start }}-{{ row.end }}</td>

                <td>
                  <v-text-field readonly solo flat dense filled hide-details :value="row.duration"></v-text-field>
                </td>
                <td>
                  <v-switch v-model.trim="row.is_active" inset :true-value="1" :false-value="0" color="green"
                    hide-details class="mt-0"></v-switch>
                </td>
                <td>

                  <v-tooltip top content-class="custom-top-tooltip">
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon @click="viewSlotData.splice(index, 1)" color="deep-orange" v-bind="attrs" v-on="on"
                        align="center">
                        mdi-delete
                      </v-icon>
                    </template>
                    <span>Click here to delete </span>
                  </v-tooltip>

                </td>
              </tr>
            </table>
          </v-container>
        </template>
        <template v-slot:action>
          <v-btn class="mx-2 custom-grey-border custom-bold-button text-white" text-color="white" color="cyan"
            v-on:click="updateSlots()">
            Save
          </v-btn>
          <v-btn class="mx-2 custom-grey-border custom-bold-button" v-on:click="viewSlots = !viewSlots">
            Close
          </v-btn>
        </template>
      </Dialog>
    </div>
    <div v-if="is_house_type_available == '0'">
      <v-card flat class="custom-grey-border remove-border-radius">
        <div v-if="allSlots?.length > 0">
          <div v-for="(slot_data, index) in allSlots" :key="index">
            <v-card-title class="headline grey lighten-4">


              <h3 class="font-weight-700 custom-headline color-custom-blue">Slots Duration ({{ slot_data?.slot_type ??
                slot_data?.house_type }})
              </h3>
              <v-spacer></v-spacer>
              <span class="mr-4 mt-2">
                <v-tooltip top content-class="custom-top-tooltip ">
                  <template v-slot:activator="{ on, attrs }">
                    <span v-bind="attrs" v-on="on">
                      <!-- <v-chip label outlined :color="slot_data?.is_product_sync == 1 ? 'blue' : 'red'"
                        class="text-white">
                        {{ slot_data?.is_product_sync == 1 ? 'SYNCED' : 'NOT SYNCED' }}
                      </v-chip> -->
                    </span>
                  </template>

                  <span>Product Sync Status with the Stripe</span>
                </v-tooltip>

              </span>
              <div class="d-flex">
                <v-tooltip top content-class="custom-top-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <v-switch v-model="slot_data.activated" inset :true-value="1" :false-value="0" color="green"
                      @change="onStatusChange(index, slot_data.activated)" hide-details class="mt-2"></v-switch>
                  </template>
                  <span>Active/In Active All Slots </span>

                </v-tooltip>
                <v-tooltip top content-class="custom-top-tooltip">
                  <template v-slot:activator="{ on, attrs }">
                    <v-icon @click=" confirmDeleteSchedule(slot_data?.id)" color="deep-orange" large v-bind="attrs"
                      v-on="on">
                      mdi-delete
                    </v-icon>
                  </template>
                  <span>Click here to delete</span>
                </v-tooltip>

                <!-- 
                <div class="d-flex justify-content-end m-3" style="justify-content: right;">
                  <v-btn class="mx-2 custom-grey-border custom-bold-button text-white" color="cyan">
                    Save
                  </v-btn>
                </div> -->

              </div>

            </v-card-title>
            <v-card-text class="p-6 font-size-16">
              <table width="100%" style="border-collapse: collapse">
                <thead>
                  <tr style="background-color: #e5e1e1">
                    <th style="padding: 10px; text-align: center; font-weight: bold">
                      Slots Start
                    </th>
                    <th style="padding: 10px; text-align: center; font-weight: bold">
                      Slots End
                    </th>

                    <th style="padding: 10px;   font-weight: bold">
                      Status
                    </th>
                    <th style="padding: 10px; text-align: center; font-weight: bold">
                      Delete
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(slot, slotIndex) in slot_data?.slots" :key="slotIndex" :style="{
                    backgroundColor: slotIndex % 2 != 0 ? '#f5f5f5' : '#ffffff',
                    borderBottom: '1px solid #e5e1e1',
                    padding: '10px'
                  }">
                    <td align="center" valign="middle" style="padding: 10px">
                      {{ slot?.start }}
                    </td>
                    <td align="center" valign="middle" style="padding: 10px">
                      {{ slot?.end }}
                    </td>
                    <td>
                      <v-switch v-model.trim="slot.is_active" inset :true-value="1" :false-value="0" color="green"
                        @click="updateSlots(slot_data?.id, slot_data?.slots)" hide-details class="mt-0"></v-switch>
                    </td>
                    <td valign="middle" align="center">
                      <v-tooltip top content-class="custom-top-tooltip">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon @click="confirmDeleteSlot(slot_data?.id, slotIndex, slot_data?.slots)"
                            color=" deep-orange" :disabled="slotIndex == 0" v-bind="attrs" v-on="on" align="center">
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Click here to delete slot permanently. </span>
                      </v-tooltip>
                    </td>

                  </tr>

                </tbody>
              </table>
            </v-card-text>
          </div>
        </div>
        <div v-else class="mt-3 mb-3">
          <p class="m-0 row-not-found text-center font-weight-500 font-size-16">
            <img :src="$assetURL('media/error/empty.png')" class="row-not-found-image" />
            Uhh... There are no slots at the moment.
          </p>
        </div>
      </v-card>
    </div>
    <Dialog :commonDialog="deleteConfirmationDialog" v-on:close="deleteConfirmationDialog = false"
      v-if="deleteConfirmationDialog" :dialog-width="500">
      <template v-slot:title> Are you sure? </template>
      <template v-slot:body>
        <v-row>
          <v-col md="12" class="py-0">
            <p class="mt-0" style="line-height: 18px">
              Are you sure want to delete the slots?
              <br />
              Slots can not be recovered once deleted?
            </p>
          </v-col>
        </v-row>
      </template>
      <template v-slot:action>
        <v-btn depressed tile @click="deleteConfirmationDialog = false">
          NO</v-btn>
        <v-btn class="white--text" depressed color="red" tile @click="deleteSchedule()">
          YES
        </v-btn>
      </template>
    </Dialog>
    <Dialog :commonDialog="confirmDeleteDialog" v-on:close="confirmDeleteDialog = false" v-if="confirmDeleteDialog"
      :dialog-width="500">
      <template v-slot:title> Are you sure? </template>
      <template v-slot:body>
        <v-row>
          <v-col md="12" class="py-0">
            <p class="mt-0" style="line-height: 18px">
              Are you sure want to delete the slot?
              <br />
              Slot can not be recovered once deleted?
            </p>
          </v-col>
        </v-row>
      </template>
      <template v-slot:action>
        <v-btn depressed tile @click="confirmDeleteDialog = false">
          NO</v-btn>
        <v-btn class="white--text" depressed color="red" tile @click="updateSlots(slotDataId, slotDataSlots)">
          YES
        </v-btn>
      </template>
    </Dialog>
  </div>
</template>
<script>
import { GET, POST, DELETE } from "@/core/services/store/request.module";
import Dialog from "@/view/pages/partials/Dialog.vue";
import ListingTable from "@/view/pages/partials/Listing-Table.vue";
import { cloneDeep } from "lodash";

export default {
  data() {
    return {
      allSlots: [],
      viewSlots: false,
      deleteConfirmationDialog: false,
      confirmDeleteDialog: false,
      statusUpdate: [1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1, 1],
      viewSlotData: [],
      deleteSlotId: 0,
      slotDataSlots: 0,
      slotDataId: 0,
    };
  },
  props: {
    service_id: {
      type: String,
      default: null,
      required: false,
    },
    slot_type: {
      type: String,
      default: null,
    },
    is_house_type_available: {
      type: String,
      default: null,
    },
  },
  components: {
    ListingTable,
    Dialog,
  },

  methods: {
    confirmDeleteSchedule(id) {
      this.deleteSlotId = id;
      this.deleteConfirmationDialog = true;
    },
    deleteSchedule() {
      // this.allSlots.splice(index, 1)
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(DELETE, {
          url: "delete-slot/" + _this.deleteSlotId,
        })
        .then(() => {
          _this.getSlots();
          _this.deleteConfirmationDialog = false;

        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    onStatusChange(index, value) {
      this.allSlots[index].slots.forEach(element => {
        element.is_active = value;
      });
      this.updateAllSlots(value, this.allSlots[index].id, this.allSlots[index]?.slots);
    },



    updateAllSlots(value, id, data) {
      const _this = this;

      _this.pageLoading = true;
      _this.$store
        .dispatch(POST, {
          url: "update-all-slots",
          data:
          {
            status: value,
            data: data,
            id: id,
          }
        })
        .then(() => {
          _this.getSlots();

        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    confirmDeleteSlot(slotDataId, index, slots) {

      this.slotDataId = slotDataId;
      this.slotDataSlots = cloneDeep(slots);
      this.slotDataSlots.splice(index, 1);
      this.confirmDeleteDialog = true;

    },
    updateSlots(update_slot_id = null, slot_data = null) {
      const _this = this;
      let data = slot_data ?? this.viewSlotData;
      if (!data) return false;

      let slotId = update_slot_id ?? _this.selectedTypeId;

      _this.pageLoading = true;
      _this.$store
        .dispatch(POST, {
          url: "update-slots/" + slotId,
          data:
          {
            data: data
          }
        })
        .then(() => {
          _this.selectedTypeId = null;
          _this.viewSlotData = [];
          _this.viewSlots = false;
          _this.confirmDeleteDialog = false;
          _this.getSlots();

        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    getSlots() {
      const _this = this;
      _this.pageLoading = true;
      _this.$store
        .dispatch(GET, {
          url: "get-slots/" + _this.service_id,
        })
        .then(({ data }) => {
          _this.allSlots = data;
        })
        .catch((error) => {
          _this.logError(error);
        })
        .finally(() => {
          _this.pageLoading = false;
        });
    },
    viewSlotInfo(data) {
      if (!data) {
        return false;
      }
      this.selectedWeekId = Number(data.week_id);
      this.viewSlotData = data?.slots;
      this.selectedTypeId = data?.id;
      this.viewSlots = true;
    },
  },
  mounted() {
    this.service_id = this.$route.params?.id;
    this.getSlots();
  },
};
</script>
